import React from 'react';
import { isMoneyTicketDeadlineOverdue } from '../../Helpers/isMoneyTicketDeadlineOverdue.helper';
import CSSZSickLeaveCertificateDetailItem from './CSSZSickLeaveCertificateDetailItem';
import styles from './CSSZSickLeaveMoneyTicketDetailItem.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import { DocumentItem } from '../../../../graphql/graphql';
import moment from 'moment';

export enum MoneyTicketType {
	SHORT,
	LONG,
}

interface Props {
	item: DocumentItem;
	type?: MoneyTicketType;
}

const CSSZSickLeaveMoneyTicketDetailItem: React.FC<Props> = ({
	item,
	type = MoneyTicketType.LONG,
}) => {
	const { extra: { dueTo: deadline, isSickLeaveFinished } = {} } = item;

	if (isSickLeaveFinished) {
		return (
			<Text
				tx='component.CSSZSickLeaveCertificateDetail.moneySlipFinished'
				inline
			/>
		);
	}

	if (!deadline) {
		return <></>;
	}

	const isOverdue = isMoneyTicketDeadlineOverdue(deadline);
	const formattedDeadline = moment(deadline, 'YYYY-MM-DD').format('DD.MM.YYYY');

	if (type === MoneyTicketType.SHORT) {
		return (
			<span className={isOverdue ? styles.danger : styles.success}>
				{formattedDeadline}
			</span>
		);
	}

	const value = (
		<span className={isOverdue ? styles.danger : styles.success}>
			<Text
				tx='component.CSSZSickLeaveCertificateDetail.moneySlipIssueLatestBy'
				txParams={{ date: formattedDeadline }}
				inline
			/>
		</span>
	);

	return (
		<CSSZSickLeaveCertificateDetailItem
			title='component.CSSZSickLeaveCertificateDetail.moneySlipToIssue'
			value={value}
		/>
	);
};

export default CSSZSickLeaveMoneyTicketDetailItem;
